<template>
  <div v-if="this.$store.state.questions.length > 0 && ((section === 'main' && this.checkIfMainSectionIsShown(this.$store.state.questions)) || (section !== 'main'))">
    <br/>
    <!--Questions-->
    <h5
      v-if="this.$store.state.questions.length > 0"
      name="question"
      class="text-center"
    >
      {{ computeCaption(this.fields_en['please_answer_to_the_best_of_your_knowledge'], this.$store.state.lang.value.toLowerCase()) }}
    </h5>
    <div class="row">
      <div class="col-md-12" :class="section === 'main' ? [validatedSectionClass, generalSection] : ''" @focusin="focusedFlag = true">
        <div
          class="row question"
          :id="'question_' + question.id"
          v-for="(question, index) in this.$store.state.questions"
          :key="question.id"
        >
          <div class="col-md-10 col-md-offset-1" v-if="checkVisibilityOfQuestion(question) === true && question['available'] === true && question['group_bill_type'] === section">
            <div class="form-group">
              <div class="row">
                <div class="col-md-7">
                  <label
                    :for="'question' + question.id"
                    class="text-none control-label required"
                  >
                    {{ computeCaption(question.name, $store.state.lang.value.toLowerCase()) }}
                  </label>
                </div>
                <div class="col-md-5">
                  <div v-if="question.type === 'Combobox Toggle'">
                    <el-radio-group
                      size="small"
                      value-key="answer_id"
                      :name="question.valueHolder === undefined || question.valueHolder.length === 0 ? 'invalidQuestion' : ''"
                      v-model="question.valueHolder"
                      @change="onAnswerChange(question)"
                    >
                      <el-radio-button
                        v-for="answer_id in question.sorted_answer_ids"
                        v-if="question['answers'][answer_id]['available']"
                        class="select-danger"
                        :class="question['answers'][answer_id]['strikethrough'] === true ? 'strikethrough' : ''"
                        tabindex="0"
                        :key="answer_id"
                        :label="question['answers'][answer_id].name"
                        :value="{
                                  answer_id: answer_id,
                                  answer_name: question['answers'][answer_id].name
                                }"
                      >{{ computeCaption(question['answers'][answer_id].name, $store.state.lang.value.toLowerCase()) }}
                      </el-radio-button>
                    </el-radio-group>
                  </div>
                  <div v-if="question.type === 'Combobox'">
                    <el-select size="large"
                               placeholder="Single Select"
                               :name="question.valueHolder === undefined || question.valueHolder.length === 0 ? 'invalidQuestion' : ''"
                               @change="onAnswerChange(question)"
                               filterable
                               v-model="question.valueHolder">
                      <el-option v-for="option in question.sorted_answer_ids"
                                 v-if="question['answers'][option]['available']"
                                 class="select-danger"
                                 :value="question['answers'][option].name"
                                 :label="computeCaption(question.answers[option].name, $store.state.lang.value.toLowerCase()) "
                                 :class="question['answers'][option]['strikethrough'] === true ? 'strikethrough' : ''"
                                 :key="option">
                      </el-option>
                    </el-select>
                  </div>
                  <div v-if="question.type === 'Barcode'">
                    <scanning-module usage="questions" :question="question"></scanning-module>
                  </div>
                  <div v-if="question.type === 'Text'">
                    <el-input
                      :id="'question' + question.id"
                      type="textarea"
                      :name="question.value === null || question.value.length === 0 ? 'invalidQuestion' : ''"
                      @input="onAnswerChange(question)"
                      v-model="question.value"
                      onkeydown="if (arguments[0].code === undefined) { return false} if (arguments[0].code.includes(['Space']) && arguments[0].target.value === '') { return false }"
                    >
                    </el-input>
                  </div>
                  <div v-if="question.type === 'Number'">
                    <el-input
                      :id="'question' + question.id"
                      type="number"
                      inputmode="numeric"
                      :name="question.value === null || question.value === '' ? 'invalidQuestion' : ''"
                      @input="onAnswerChange(question)"
                      v-model="question.value"
                      onkeydown="if (arguments[0].code === undefined) { return false} if (arguments[0].code.includes(['Space']) && arguments[0].target.value === '') { return false }"
                    >
                    </el-input>
                  </div>
                  <div v-if="question.type === 'Date'">
                    <el-date-picker
                      :id="'question' + question.id"
                      v-model="question.value"
                      type="date"
                      class="w-100"
                      :name="question.value === null || question.value === '' ? 'invalidQuestion' : ''"
                      format="MM/dd/yyyy"
                      value-format="yyyy-MM-dd"
                      placeholder="Select date"
                      :picker-options="{disabledDate: (time) => checkDisabledDateQuestion(time, question)}"
                    >
                    </el-date-picker>
                  </div>
                  <div v-if="question.type === 'Multichoice Toggle'">
                    <el-checkbox-group
                      :name="question.multiple === '' || question.multiple.length === 0 ? 'invalidQuestion' : ''"
                      v-model="question.multiple"
                      @change="onAnswerChange(question)"
                    >
                      <el-checkbox-button
                        v-for="answer_id in question.sorted_answer_ids"
                        v-if="question['answers'][answer_id]['available']"
                        class="select-danger"
                        tabindex="0"
                        :key="answer_id"
                        :label="question['answers'][answer_id].name"
                        :class="question['answers'][answer_id]['strikethrough'] === true ? 'strikethrough' : ''"
                        :value="question['answers'][answer_id].name"
                      >
                        {{ computeCaption(question['answers'][answer_id].name, $store.state.lang.value.toLowerCase()) }}
                      </el-checkbox-button>
                    </el-checkbox-group>
                  </div>
                  <div v-if="question.type === 'Multichoice'">
                    <el-select size="large"
                               v-model="question.multiple"
                               @change="onAnswerChange(question)"
                               :name="question.multiple.length === 0 ? 'invalidQuestion' : ''"
                               multiple
                               filterable
                               collapse-tags
                               placeholder="Select">
                      <el-option
                        class="select-danger"
                        v-for="answer_id in question.sorted_answer_ids"
                        v-if="question['answers'][answer_id]['available']"
                        :key="answer_id"
                        :label="computeCaption(question['answers'][answer_id].name, $store.state.lang.value.toLowerCase())"
                        :class="question['answers'][answer_id]['strikethrough'] === true ? 'strikethrough' : ''"
                        :value="question['answers'][answer_id].name">
                      </el-option>
                    </el-select>
                  </div>
                  <div class="default-grey font-small" v-show="getQuestionDescription(question)" v-html="getQuestionDescription(question) || ''"></div>
                </div>
                <small class="text-danger col-xs-12 el-col-md-offset-1" v-if="$store.state.questionsErrorArray.includes(question['id'])">
                  {{ computeCaption('This field is required', $store.state.lang.value.toLowerCase()) }}
                </small>
                <div v-if="question.type === 'Combobox' || question.type === 'Combobox Toggle' || question.type === 'Multichoice' || question.type === 'Multichoice Toggle'">
                  <recursive-question :question="question"></recursive-question>
                </div>
              </div>
            </div>
          </div>
        </div>
        <br />
        <div>
          <small class="text-danger col-md-10 el-col-md-offset-1" v-if="validatedSectionClass !== 'validated-section-class'">{{ computeCaption(questionError, this.$store.state.lang.value.toLowerCase()) }}
          </small>
        </div>
        <br />
      </div>
    </div>
    <br/>
  </div>
</template>

<script>
/* eslint no-eval: 0 */
import RecursiveQuestions from './RecursiveQuestions'
import {Autocomplete, Input, Drawer, Button, RadioGroup, Radio, RadioButton, DatePicker, CheckboxGroup, CheckboxButton} from 'element-ui'
import {mapFields} from 'vee-validate'
import ScanningModule from './ScanningModule'
import {TranslationsUtils} from '../../../../utils/Translations'
import {QuestionUtils} from '../../../../utils/Questions'

export default {
  mixins: [TranslationsUtils, QuestionUtils],
  components: {
    ScanningModule,
    [Input.name]: Input,
    [DatePicker.name]: DatePicker,
    [Autocomplete.name]: Autocomplete,
    [Drawer.name]: Drawer,
    [Button.name]: Button,
    [RadioGroup.name]: RadioGroup,
    [Radio.name]: Radio,
    [RadioButton.name]: RadioButton,
    [CheckboxButton.name]: CheckboxButton,
    [CheckboxGroup.name]: CheckboxGroup,
    'recursive-question': RecursiveQuestions
  },
  props: ['section'],
  data () {
    return {
      generalSection: 'general-inactive-section',
      validatedSectionClass: '',
      questionError: '',
      focusedFlag: false,
      questionErrorDate: [],
      model: {
        questions: this.$store.state.questions
      },
      singlePage: this.$store.state.configs.SINGLE_PAGE_ORDERS || '',
      fields_en: {
        please_answer_to_the_best_of_your_knowledge: 'Please answer to the best of your knowledge'
      }
    }
  },
  methods: {
    validate () {
      let token = localStorage.getItem('token')
      let validator = true
      this.questionError = ''
      if (this.$store.state.questions !== []) {
        if (this.$store.state.configs['SINGLE_PAGE_ORDERS'] === false && !token) {
          this.$store.state.icdCodes = []
        }
        let questionValidation = this.validateQuestions(this.$store.state.questions, validator)
        if (questionValidation === false) {
          if (this.$store.state.configs['SINGLE_PAGE_ORDERS'] === false && !token) {
            this.$store.state.icdCodes = []
          }
          this.questionError = 'All questions are required'
          if (this.$validator.errors.items.length === 0) {
            this.focusQuestions()
          }
          return false
        }
        return this.questionError
      }
    },
    focusQuestions () {
      let invalidQuestions = document.getElementsByName('invalidQuestion')
      if (invalidQuestions.length) {
        let panel = document.getElementsByClassName('main-panel')[0]
        let top = invalidQuestions[0].getBoundingClientRect().top
        panel.scrollTop = panel.scrollTop + top - 130
        invalidQuestions[0].focus()
      }
    },
    onAnswerChange (question) {
      let answers = Object.values(question['answers'])
      answers.forEach(function (answer) {
        if (answer.name === question.valueHolder) {
          question.value = {answer_id: answer.id, answer_name: answer.name}
          question['multiple_ids'] = []
          question['multiple_ids'].push(answer.id)
        }
      })
      if (question.type === 'Multichoice' || question.type === 'Multichoice Toggle') {
        question['multiple_ids'] = []
        let objectOfAnswer = Object.values(question['answers'])
        let possibleAnswers = []
        objectOfAnswer.forEach(element => possibleAnswers.push(element['name']))
        let possibleAnswersKeys = Object.keys(question['answers'])
        let multipleAnswersArray = question['multiple']
        multipleAnswersArray.forEach(function (answerName) {
          let answerIndex = possibleAnswers.indexOf(answerName)
          if (answerIndex !== -1) {
            question['multiple_ids'].push(possibleAnswersKeys[answerIndex])
          }
        })
      }
      question.valid = !!question.value
    },
    switchInternational () {
      this.$store.state.international = this.nationality === 'International'
    },
    questionValidationWatch () {
      this.$store.state.icdCodes = []
      this.validatedSectionClass = ''
      let validator = true
      let questionValidation = this.validateQuestions(this.$store.state.questions, validator)
      if (questionValidation === false) {
        this.$store.state.icdCodes = []
        if (this.focusedFlag) {
          this.validatedSectionClass = 'invalid-section-class'
          this.generalSection = 'general-invalid-section'
        }
      } else {
        this.validatedSectionClass = 'validated-section-class'
        this.generalSection = 'general-inactive-section'
      }
    },
    questionRules () {
      // eslint-disable-next-line no-unused-vars
      let context = Object.assign(this.$store.state.user)
      // eslint-disable-next-line no-unused-vars
      let vue = this
      eval(this.$store.state.questionsRules['expression'])
      return true
    },
    questionWatchFunction () {
      this.questionValidationWatch()
      this.questionRules()
    }
  },
  computed: {
    ...mapFields(['questions'])
  },
  mounted () {
    this.$watch('$store.state.questions', this.questionWatchFunction, {deep: true})
  },
  created () {
    this.$store.state.questionsMap = []
    this.$store.state.questionsRules['expression'] = ''
    this.firstTraversal(this.$store.state.questions)
  },
  watch: {
    '$store.state.user': {
      handler (before) {
        this.questionRules()
      },
      deep: true
    },
    '$store.state.questions': {
      handler () {
        this.$store.state.questionsMap = []
        this.$store.state.questionsRules['expression'] = ''
        this.firstTraversal(this.$store.state.questions)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../../../assets/sass/paper/_variables.scss';
.general-inactive-section:focus-within {
  border-left-color: $primary-color !important;
}
.strikethrough {
  text-decoration: line-through;
  text-decoration-color: $primary-color;
  text-decoration-thickness: 2px;
}
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Utils/QuestionsSection.vue